<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="College Subscription List">
        <!--<div class="text-right">
          <b-button variant="success" href="/#/backend/forms/add-college-subscriptions"
            >+ Add College Subscription</b-button
          >
        </div>
        <br />-->
        <div class="d-flex justify-content-end mb-2">
          <input
            class="form-control"
            type="text"
            placeholder="Search..."
            aria-label="Search"
            style="width: 300px"
          />
        </div>
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">College Name</b-th>
              <b-th class="text-center">Subscription</b-th>
              <b-th class="text-center">Subscription Start Date</b-th>
              <b-th class="text-center">Students Count</b-th>
              <b-th class="text-center">Validity (days)</b-th>
              <b-th class="text-center">Price</b-th>
              <b-th class="text-center">Discount</b-th>
              <b-th class="text-center">Status</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="banner in banners" :key="banner.id">
              <b-td class="text-center">
                {{ banner.sno }}
              </b-td>
              <b-td class="text-center">
                {{ banner.collename }}
              </b-td>
              <b-td class="text-center">
                {{ subscriptions.subscriptions.name }}
              </b-td>
              <b-td class="text-center">
                {{ subscriptions.subscription_start_date }}
              </b-td>
              <b-td class="text-center">
                {{ subscriptions.studentsCount }}
              </b-td>
              <b-td class="text-center">
                {{ subscriptions.subscriptions.validity }}
              </b-td>
              <b-td class="text-center">
                {{ subscriptions.subscriptions.price }}
              </b-td>
              <b-td class="text-center">
                {{ subscriptions.subscriptions.discount }}
              </b-td>
              <b-td class="text-center">
                <b-button
                  size="sm"
                  variant="alt-primary"
                  href="/#/backend/forms/subscription-summary"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </b-td>
              <b-td class="text-center">
                <b-button
                  size="sm"
                  variant="alt-primary"
                  href="/#/backend/forms/subscription-summary"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </b-td>
              <b-td class="text-center">
                <b-button
                  size="sm"
                  variant="alt-primary"
                  href="/#/backend/forms/subscription-summary"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </b-td>
              <b-td class="text-center">
                <b-badge :variant="banner.labelVariant">{{
                  banner.labelText
                }}</b-badge>
              </b-td>
              <b-td class="text-center">
                <b-btn-group>
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    href="/#/backend/forms/add-college-subscriptions"
                  >
                    <i class="fa fa-fw fa-pencil-alt"></i>
                  </b-button>
                  <b-button size="sm" variant="alt-primary" href="">
                    <i class="fa fa-fw fa-times"></i>
                  </b-button>
                </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      subscriptions: [],
      buttonVariant: "success",
    };
  },
  mounted() {
    this.getCollegeSubscriptions();
  },
  methods: {
    async getCollegeSubscriptions(){
      await axios
        .get(`${this.$store.getters.baseUrl}/college_subscriptions`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
